<template>
    <div>
        <b-row>
            <b-col>
                <label for="nombre">Buscar</label>
                <el-input id="filter"
                          name="filter"
                          type="text"
                          size="small"
                          placeholder="Buscar"
                          v-model="params.filter"
                />
            </b-col>
            <b-col>
                <label class="w-100">&nbsp;</label>
                <b-btn variant="primary"
                       size="sm"
                       @click="fetchProviders(true)"
                >
                    <i class="fa fa-search"/> Buscar
                </b-btn>
                <b-btn class="mx-2"
                       variant="secondary"
                       size="sm"
                       @click="_resetParams"
                >
                    <i class="fa fa-eraser"/> Limpiar
                </b-btn>
            </b-col>
        </b-row>

        <b-table responsive
                 striped
                 small
                 hover
                 bordered
                 thead-class="table-active"
                 class="mt-2"
                 :fields="fields"
                 :items="providers.data"
                 show-empty
                 empty-text="No hay proveedores para mostrar"
        >
            <template v-slot:cell(selection)="row"
                      class="text-center"
            >
                <b-form-checkbox :disabled="!validarPermisoComponente('empresa-editar-proveedores')" v-model="row.item.selection"
                                 @change="associateProvider(row.item.id)"
                />
            </template>

        </b-table>

        <b-row>
            <b-col class="text-right">
                <el-pagination v-model="params.page"
                               @current-change="fetchProviders"
                               @size-change="fetchProviders(true)"
                               :current-page.sync="params.page"
                               :page-sizes="[10, 30, 50, 100]"
                               :page-size.sync="params.per_page"
                               :total="providers.total"
                               layout="total, sizes, prev, pager, next"
                               small
                />
            </b-col>
        </b-row>
    </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import {createCompanyProvider} from '../../../servicios/providers/actions';
import { validarPermisoComponente } from "@/plugins/acl";

export default {
    name: 'index',
    data() {
        return {
            fields: [
                {
                    key: 'identification',
                    label: 'Identificación',
                    thStyle: 'width: 150px',
                    sortable: false,
                },
                {
                    key: 'name',
                    label: 'Nombre',
                    thStyle: 'width: 300px',
                    sortable: false
                },
                {
                    key: 'address',
                    label: 'Dirección',
                    sortable: false,
                },
                {
                    key: 'telephone',
                    label: 'Teléfono',
                    thStyle: 'width: 150px',
                    sortable: false,
                },
                {
                    key: 'selection',
                    label: 'Selección',
                    thStyle: 'width: 110px',
                    tdClass: 'text-center',
                    thClass: 'text-center',
                    sortable: false,
                }
            ],
            validarPermisoComponente: validarPermisoComponente,
        };
    },
    computed: {
        ...mapState('providers', [
            'providers',
            'params'
        ]),
        ...mapState('empresa', [
            'selectedEmpresa'
        ])
    },
    async mounted() {
        await this._resetParams();
    },
    methods: {
        ...mapActions('providers', [
            'fetchProviders',
            'createCompanyProvider'
        ]),
        ...mapMutations('providers', [
            'resetParams'
        ]),
        async _resetParams() {
            this.resetParams();
            await this.fetchProviders(true);
        },
        async associateProvider(slq_provider_id){
            const data = {
                slq_provider_id,
                slq_company_id: this.selectedEmpresa.id
            }

            await this.createCompanyProvider(data);
        }
    }
};
</script>
